/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getVideoBlob.defs.js";
export { main as default } from "./getVideoBlob.defs.js";
